export { default } from './TCHHero';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/Hero/TCHHero/index.ts